import React, { memo } from 'react';
export function BeforeAfter() {
  return <section className="bg-warm-deep py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-black mb-16 leading-tight" data-id="element-3">
          <span className="text-red-500" data-id="element-4">Before</span> vs{' '}
          <span className="italic text-green-600" data-id="element-5">After</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6">
          {/* Before Column */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border-t-8 border-red-500" data-id="element-7">
            <h3 className="font-sans font-bold text-2xl text-center text-gray-800 mb-8 pb-4 border-b border-gray-200" data-id="element-8">
              Before The Pawfect Shot MegaPack
            </h3>
            <ul className="space-y-6" data-id="element-9">
              {['Random snapshots', 'Blurry moments', 'Bad lighting', 'Awkward angles', 'Missed expressions', 'Guessing every time'].map((item, index) => <li key={index} className="flex items-center" data-id="element-10">
                  <span className="text-red-500 text-2xl mr-4" data-id="element-11">❌</span>
                  <span className="font-sans text-lg text-gray-600" data-id="element-12">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* After Column */}
          <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border-t-8 border-green-500 transform md:scale-105 relative z-10" data-id="element-13">
            <div className="absolute -top-4 -right-4 bg-orange text-white font-bold px-4 py-1 rounded-full shadow-md transform rotate-12" data-id="element-14">
              YOUR NEW REALITY
            </div>
            <h3 className="font-sans font-bold text-2xl text-center text-black mb-8 pb-4 border-b border-gray-200" data-id="element-15">
              After The Pawfect Shot MegaPack
            </h3>
            <ul className="space-y-6" data-id="element-16">
              {['Clear, beautiful dog portraits', 'Better action and personality shots', 'More confidence using your phone camera', 'More meaningful memories captured', 'Less frustration', 'Photos worth sharing and printing'].map((item, index) => <li key={index} className="flex items-start" data-id="element-17">
                  <span className="text-green-500 text-2xl mr-4 mt-0.5" data-id="element-18">
                    ✅
                  </span>
                  <span className="font-sans text-lg font-medium text-gray-900" data-id="element-19">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}